import React, { useState } from 'react';
import { X, Video, Link as LinkIcon } from 'lucide-react';
import VideoDropZone from './VideoDropZone';

export function extractYouTubeId(url) {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
}

function VideoThumb({ url, index, onRemove }) {
  const ytId = extractYouTubeId(url);
  const isUploaded = url.includes('/api/uploads/') || url.includes('/api/files/');
  return (
    <div className="relative group rounded-lg overflow-hidden border border-earth/10 bg-black/5">
      {ytId ? (
        <img src={`https://img.youtube.com/vi/${ytId}/mqdefault.jpg`} alt={`Video ${index + 1}`} className="w-full h-24 object-cover" />
      ) : isUploaded ? (
        <video src={url} className="w-full h-24 object-cover" preload="metadata" muted />
      ) : (
        <div className="w-full h-24 flex items-center justify-center bg-earth/5"><Video size={20} className="text-earth/30" /></div>
      )}
      <div className="absolute bottom-1 left-1 right-8 bg-black/60 text-white text-[9px] px-2 py-0.5 rounded truncate font-sans">
        {ytId ? 'YouTube' : isUploaded ? 'Uploaded' : 'Video'} {index + 1}
      </div>
      <button onClick={onRemove} className="absolute top-1 right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`remove-video-${index}`}>
        <X size={10} />
      </button>
    </div>
  );
}

export default function ProductVideos({ videos, onChange }) {
  const [newUrl, setNewUrl] = useState('');

  const add = (url) => {
    if (url) onChange(prev => (prev.includes(url) ? prev : [...prev, url]));
  };

  const addFromInput = () => {
    add(newUrl.trim());
    setNewUrl('');
  };

  return (
    <div data-testid="video-section">
      <label className="text-[10px] uppercase tracking-wider text-earth/50 font-sans font-semibold mb-2 block">Product Videos</label>
      {videos.length > 0 && (
        <div className="grid grid-cols-2 gap-3 mb-3">
          {videos.map((url, i) => (
            <VideoThumb key={url} url={url} index={i} onRemove={() => onChange(prev => prev.filter(v => v !== url))} />
          ))}
        </div>
      )}
      <VideoDropZone onUpload={add} />
      <div className="flex items-center gap-2 mt-2">
        <div className="flex-1 flex items-center gap-2 border border-earth/15 rounded-md px-3 py-2 bg-cream/30">
          <LinkIcon size={13} className="text-earth/30 flex-shrink-0" />
          <input
            value={newUrl}
            onChange={(e) => setNewUrl(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && addFromInput()}
            placeholder="Or paste YouTube URL (e.g. https://youtube.com/watch?v=...)"
            className="w-full bg-transparent border-0 p-0 text-sm font-sans text-earth-dark focus:ring-0 focus:outline-none placeholder:text-earth/25"
            data-testid="video-url-input"
          />
        </div>
        <button onClick={addFromInput} disabled={!newUrl.trim()} className="bg-saffron/10 text-saffron font-sans font-semibold text-xs px-4 py-2.5 rounded-md hover:bg-saffron/20 transition-colors disabled:opacity-30 flex items-center gap-1" data-testid="add-video-btn">
          <Video size={13} /> Add
        </button>
      </div>
    </div>
  );
}
